import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "dropdown topbar-item" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = { class: "dropdown-header" };
const _hoisted_4 = {
    class: "dropdown-item",
    href: "#"
};
const _hoisted_5 = {
    class: "dropdown-item",
    href: "#"
};
const _hoisted_6 = {
    class: "dropdown-item",
    href: "#"
};
const _hoisted_7 = {
    class: "dropdown-item",
    href: "#"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IconifyIcon = _resolveComponent("IconifyIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
            ref: "dropdownButtonRef",
            "aria-expanded": "false",
            "aria-haspopup": "true",
            class: "topbar-button",
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
            //@ts-ignore
            (...args) => ($setup.toggleDropdown && $setup.toggleDropdown(...args)), ["prevent"]))
        }, [
            _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_IconifyIcon, {
                    class: "fs-24",
                    icon: "solar:user-circle-bold-duotone"
                })
            ])
        ], 512),
        _createElementVNode("div", {
            ref: "dropdownMenuRef",
            class: _normalizeClass(["dropdown-menu dropdown-menu-end", { 'show': $setup.isOpen }])
        }, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString($setup.userName) + " خوش آمدی!", 1),
            _createElementVNode("a", _hoisted_4, [
                _createVNode(_component_IconifyIcon, {
                    class: "align-middle me-2 fs-18",
                    icon: "solar:calendar-broken"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "align-middle" }, "برنامه های من", -1))
            ]),
            _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_IconifyIcon, {
                    class: "align-middle me-2 fs-18",
                    icon: "solar:wallet-broken"
                }),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "align-middle" }, "قیمت گذاری", -1))
            ]),
            _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_IconifyIcon, {
                    class: "align-middle me-2 fs-18",
                    icon: "solar:help-broken"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "align-middle" }, "کمک", -1))
            ]),
            _createElementVNode("a", _hoisted_7, [
                _createVNode(_component_IconifyIcon, {
                    class: "align-middle me-2 fs-18",
                    icon: "solar:lock-keyhole-broken"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "align-middle" }, "قفل کردن صفحه", -1))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dropdown-divider my-1" }, null, -1)),
            _createElementVNode("a", {
                class: "dropdown-item text-danger",
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
                //@ts-ignore
                (...args) => ($setup.handleLogout && $setup.handleLogout(...args)), ["prevent"]))
            }, [
                _createVNode(_component_IconifyIcon, {
                    class: "align-middle me-2 fs-18",
                    icon: "solar:logout-3-broken"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "align-middle" }, "خروج", -1))
            ])
        ], 2)
    ]));
}
